import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Container, Jumbo, Tabs, tokens } from '@treams/treams-ui';

import LearningSubjects from './components/LearningSubjects';
import LearningTypes from './components/LearningTypes';

export default function LearningSettings() {
	const { t } = useTranslation();

	return (
		<>
			<Jumbo
				title={t('settings.learning.title')}
				description={t('settings.learning.description')}
				footer={
					<Tabs.Container mb="-1px">
						<Tabs.Item title={t('settings.learning.types.title')} path="/settings/learning/types" />
						<Tabs.Item
							title={t('settings.learning.subjects.title')}
							path="/settings/learning/subjects"
						/>
					</Tabs.Container>
				}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Switch>
					<Route path="/settings/learning/types">
						<LearningTypes />
					</Route>
					<Route path="/settings/learning/subjects">
						<LearningSubjects />
					</Route>
					<Route>
						<Redirect to="/settings/learning/types" />
					</Route>
				</Switch>
			</Container>
		</>
	);
}
